import script from "./EMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./EMenu.vue?vue&type=script&lang=ts&setup=true"

import "./EMenu.vue?vue&type=style&index=0&id=a90b542c&scoped=true&lang=css"
import "./EMenu.vue?vue&type=style&index=1&id=a90b542c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a90b542c"]])

export default __exports__